import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getAuth, signInWithCustomToken } from 'firebase/auth'

const firebaseConfig = {
	apiKey: 'AIzaSyB1k7bh013J8OWcoUFwLrR-OwyuwTrshfU',
	authDomain: 'mydoforms-hrd.firebaseapp.com',
	databaseURL: 'https://mydoforms-hrd.firebaseio.com',
	projectId: 'mydoforms-hrd',
	storageBucket: 'mydoforms-hrd.appspot.com',
	messagingSenderId: '793359194105',
}

const app = initializeApp(firebaseConfig)
const database = getDatabase(app)
export const auth = getAuth(app)

export function signInFirebaseWithCustomToken({ firebaseToken }) {
	if (!firebaseToken) return
	signInWithCustomToken(auth, firebaseToken)
		.then((result) => {
			console.log('Signed in to Firebase successfully.')
			return result
		})
		.catch((err) => console.error('Failed to sign in to Firebase:', err))
}

export default database
